module.exports = "pegasus/assets/header-fall-pets-3.jpg";